import { CreditCard, CreditCardStatus, CustomerRole } from '@generated-types';

export const v4CreditCard1Mock: CreditCard = {
    id: '4563711',
    eikaCardId: 'MDE1MjQ5OTYzMjdfNDQxMzUzKsSSxJPEgjAzXzHEmDU5MDkxOTcxNzlfQ1JFRElU',
    imagePath: 'https://skuesparebank.test.eika.no//-/media/fellesbilder/kortdesign/kredittkort/gold-visa.png',
    cardNumber: '441353******5203',
    expires: { month: 6, year: 2027 },
    status: CreditCardStatus.NORMAL,
    product: {
        code: 'KREDITTBANKEN_VISA',
        name: 'Kredittbanken Visa',
    },
    activated: true,
    cardHolder: {
        firstName: 'Possessiv',
        lastName: 'Forelder',
        role: CustomerRole.ACCOUNT_OWNER,
        customerNumber: {
            value: '09817696179',
        },
    },
    allowedCardActions: {
        payBillFromCard: false,
        transferFromCard: false,
    },
    userIsCardOwner: true,
    allowedOperations: {
        block: true,
        unblock: false,
        reorder: false,
        getVirtualCard: true,
        getPin: true,
        getUserLimit: true,
        setWallets: true,
        getChangeLimit: true,
        canTransfer: true,
        canPayBill: true,
    },
};
